const onReady = () => {
  console.log('onReady')
}

export {
  onReady,
}
